// extracted by mini-css-extract-plugin
export default {"form":"form_form__KNURO","submitBtn":"form_submitBtn__po6QM","linkToUrbanease":"form_linkToUrbanease__skTsu"};